module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/app-693690d62e04d8ec731cbab4e2c908fa.jpg";